<p-popover #contextPopover appendTo="body" styleClass="launcher-popover">
  <section aria-label="Context actions">
    <div class="launcher-section-label">Actions</div>
    <div class="launcher-grid">
      @for (item of items; track item.tool) {
        <button
          type="button"
          class="launcher-item"
          [disabled]="item.disabled"
          [attr.title]="item.warning ? item.warningMessage || item.tool.caption : item.tool.caption"
          (click)="executeAction(item); contextPopover.hide()"
        >
          <span class="launcher-item-icon">
            <i [class]="item.icon" aria-hidden="true"></i>
            @if (item.warning) {
              <i class="pi pi-exclamation-triangle launcher-warning-badge" aria-hidden="true"></i>
            }
          </span>
          <span>{{ item.tool.caption }}</span>
        </button>
      }
    </div>
  </section>
</p-popover>
<span class="launcher-trigger">
  <p-button
    type="button"
    icon="pi pi-wrench"
    [rounded]="true"
    [text]="true"
    [disabled]="!items.length"
    ariaLabel="Open context actions"
    (onClick)="contextPopover.toggle($event)"
  ></p-button>
  @if (availableCount > 0) {
    <span class="launcher-count-badge" [attr.title]="availableCount + ' available actions'">{{ availableCount }}</span>
  }
</span>

